import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { Grid, Typography } from "@material-ui/core";
import Draggable from "react-draggable";

const DraggableAnswer = (props) => {
  const {
    showDraggable,
    onDragStart,
    onDragEnd,
    onDragUpdate,
    currentQuestion,
    dragStarted,
    openNextSetModal,
    moveBack,
    classes,
  } = props;

  return (
    <Grid className={classes.draggableMainContainer}>
      <Grid className={classes.draggableContainer} id="draggable-container">
        {(!openNextSetModal && showDraggable && !moveBack) && (
          <Draggable
            onDrag={onDragUpdate}
            onStart={onDragStart}
            onStop={onDragEnd}
            position={{ x: 0, y: 0 }}
            handle="#answer-icon"
          >
            <Grid
              container
              alignItems="center"
              className={classes.draggableElement}
            >
              <img
                id="answer-icon"
                src={currentQuestion.icon}
                className={`${classes.questionImg} animate__animated animate__bounceIn`}
              />
              <Grid className="animate__animated animate__bounceIn">
                <Typography className={classes.serviceTitle}>
                  {currentQuestion.title}
                </Typography>
                <Typography className={classes.serviceDesc}>
                  {currentQuestion.desc}
                </Typography>
              </Grid>
            </Grid>
          </Draggable>
        )}
      </Grid>
      {(dragStarted || !showDraggable || openNextSetModal || moveBack) && (
        <Grid className={classes.iconTraceBack} />
      )}
    </Grid>
  );
};

export default withStyles(styles)(DraggableAnswer);
